import React from 'react';
import meImage from '../../assets/me.png';
import './About.css';

function About() {
    return (
        <div className="about-container">
            <img src={meImage} alt="Me" className="about-image" />
            <div className="about-description">
                <h2>About Me</h2>
                <p>
                    I am a DevOps Engineer with extensive experience in creating, managing, and maintaining AWS resources. I have a strong background in containerized microservices, automation, and infrastructure as code using tools such as Terraform, Ansible, and Bamboo.
                </p>
                <p>
                    Throughout my career, I have supported developers in managing AWS resources and contributed to company-wide solutions like centralized secret management, self-service platforms, and CI/CD pipeline automation. I have also focused on service mesh platforms and access management.
                </p>
                <p>
                    I have automated processes and improved existing solutions using Jenkins and Ansible. Additionally, I have provided level 2 support to multiplatform applications, documented processes, and conducted knowledge transfer to new coworkers.
                </p>
                <p>
                    I am passionate about continuous learning and enjoy sharing my knowledge through trainings and proactive support.
                </p>
            </div>
        </div>
    );
}

export default About;
